/**
 * @fileOverView
 * @description Status, pulls server up/down status<br>
 * @copyright 2015-present Flatirontek LLC
 **/

var AmpersandModel = require('ampersand-model');
var app = require("ampersand-app");

var Status = AmpersandModel.extend({

    urlRoot: function(){
        return app.config.restApiUrl + "/status";
    },

    props: {
        status : 'string'
    }

});

module.exports = Status;
